export const button = {
    slots: {
        base: 'hover:cursor-pointer justify-center font-bold',
    },
}
